<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<link href="styles/default.css" rel="stylesheet" type="text/css"/>
<title>Aunt Bee’s Delightful Desserts: More Than 350 Recipes from Mayberry, Americas’s Friendliest Town</title>
<p class="ctr" id="pz23-2"><a href="#/contents#RR_22" id="CC_22"> Mrs. Lesch’s Lemon Bread</a></p>
<p class="tx6" id="pz23-3"><i> Right on the money. </i></p>
<p class="tx5" id="pABo"><b> 1 cup sugar </b></p>
<p class="tx5" id="pA2LgO"><b> 5 tablespoons melted butter </b></p>
<p class="tx5" id="pALZc"><b> 2 eggs, beaten </b></p>
<p class="tx5" id="pAnqA"><b> ½ cup milk </b></p>
<p class="tx5" id="pAv9t"><b> 1½ cups all-purpose flour </b></p>
<p class="tx5" id="pAnu"><b> ½ teaspoon salt </b></p>
<p class="tx5" id="pAxqN"><b> 1 lemon rind, grated </b></p>
<p class="tx5" id="pAved"><b> Juice of 1 lemon </b></p>
<p class="tx5" id="pA5ng"><b> ⅓ cup sugar </b></p>
<p class="tx1" id="pATaQ"><span class="dcap">C</span>ream sugar, butter, and eggs. Add milk and dry ingredients alternately. Add lemon rind. Pour into a 9×5-inch (or two smaller pans) greased bread pans. Pull knife through batter to eliminate air bubbles. Bake at 350° for 1 hour.</p>
<p class="tx" id="pAWOT">For topping, mix lemon juice and sugar; pour over hot bread. Let bread sit overnight. Can refrigerate up to 3 weeks. Can freeze.</p>
<p class="tx" id="pAQVJ">Makes 1 or 2 loaves.</p>
<p class="txrr" id="pAXsH"> <i>Karen Mol—Grand Rapids, Michigan</i></p>
<div class="box" id="Akqc">
<p class="tx1a" id="pAOp8"> <i>Things get sweeter at the bakery when Millie arrives:</i></p>
<table id="pAUHd">
<tbody id="AUHd" style="vertical-align: top;">
<tr id="tr-AUHd-0">
<td id="td-AUHd-0-0"><p class="txtb">GOOBER:</p></td>
<td id="td-AUHd-0-1">Hey, look. She’s going into Boysinger’s Bakery.</td>
</tr>
<tr id="tr-AUHd-1">
<td id="td-AUHd-1-0"><p class="txtb">ANDY:</p></td>
<td id="td-AUHd-1-1">Oh, yeah. I bet she’s gonna work there. Mr. Boysinger said he had a new girl coming in from Mt. Pilot.</td>
</tr>
<tr id="tr-AUHd-2">
<td id="td-AUHd-2-0"><p class="txtb">HOWARD:</p></td>
<td id="td-AUHd-2-1">Hey, Andy. When’s the last time you had a cream bun?</td>
</tr>
<tr id="tr-AUHd-3">
<td id="td-AUHd-3-0"><p class="txtb">ANDY:</p></td>
<td id="td-AUHd-3-1">Ohhh.</td>
</tr>
<tr id="tr-AUHd-4">
<td id="td-AUHd-4-0"><p class="txtb">HOWARD:</p></td>
<td id="td-AUHd-4-1">Me too, you know. And I got a real craving for a cream bun right now. How ’bout you?</td>
</tr>
<tr id="tr-AUHd-5">
<td id="td-AUHd-5-0"><p class="txtb">ANDY:</p></td>
<td id="td-AUHd-5-1">A little close to lunch, Howard.</td>
</tr>
<tr id="tr-AUHd-6">
<td id="td-AUHd-6-0"><p class="txtb">HOWARD:</p></td>
<td id="td-AUHd-6-1">Oh, it’s my treat.</td>
</tr>
<tr id="tr-AUHd-7">
<td id="td-AUHd-7-0"><p class="txtb">ANDY:</p></td>
<td id="td-AUHd-7-1">Oh, I don’t know.</td>
</tr>
<tr id="tr-AUHd-8">
<td id="td-AUHd-8-0"><p class="txtb">HOWARD:</p></td>
<td id="td-AUHd-8-1">Oh, come on, Andy. It’s my treat, my treat.</td>
</tr>
<tr id="tr-AUHd-9">
<td id="td-AUHd-9-0"><p class="txtb">ANDY:</p></td>
<td id="td-AUHd-9-1">Okay. I wouldn’t stand in between you and a cream bun.</td>
</tr>
<tr id="tr-AUHd-10">
<td id="td-AUHd-10-0"><p class="txtb">HOWARD:</p></td>
<td id="td-AUHd-10-1">Well, good. How about you, Goober?</td>
</tr>
<tr id="tr-AUHd-11">
<td id="td-AUHd-11-0"><p class="txtb">GOOBER:</p></td>
<td id="td-AUHd-11-1">I have to go to work, but you owe me one.</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter22.vue?7139a1a8